import * as React from 'react';
import styled from 'styled-components';
import t from '../locales';

interface IProps {
  type: 'wa'|'pickup';
}

const YadoItemRibonView = styled.div<{ type: 'wa'|'pickup' }>`
  --height: 20px;
  height: var(--height);
  margin-bottom: 4px;
  position: relative;
  .inner {
    position: absolute;
    display: flex;
    align-items: center;
    height: var(--height);
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    background-color: ${props => props.type === 'wa' ? 'var(--pink500)' : '#BB89DE'};
    font-size: 10px;
    font-weight: bold;
    line-height: var(--height);
    color: var(--gray0);
    right: -6px;
    padding: 0 12px 0 8px;
    text-align: right;
    i {
      font-size: 16px!important;
      margin-right: 4px;
    }
    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: -6px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 6px 0 0;
      border-color: transparent;
      border-top-color: ${props => props.type === 'wa' ? '#CE5A76' : '#9E75BA'}
    }
  }
`;

const displayContent = {
  wa: {
    icon: 'icon-wa_solid',
    label: t.recommended(),
  },
  pickup: {
    icon: 'icon-bus_solid',
    label: 'Pick Up',
  }
};

const YadoItemRibon: React.FC<IProps> = (props) => {
  const { type } = props;
  const content = displayContent[type];
  if (!content) { return null; }
  return (
    <YadoItemRibonView type={type}>
      <div className="inner">
        <i className={content.icon} />
        {content.label}
      </div>
    </YadoItemRibonView>
  );
};

export default YadoItemRibon;
